module.exports = __webpack_public_path__ + "fonts/googleAuth_ico@2x.7758b7f36bae534643f54ad1148bb484.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/icons/mfa/googleAuth_ico@2x.png
// module id = 762
// module chunks = 9